import { render, staticRenderFns } from "./RegisterCompleted.vue?vue&type=template&id=ecf99480&scoped=true&"
import script from "./RegisterCompleted.vue?vue&type=script&lang=js&"
export * from "./RegisterCompleted.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCompleted.vue?vue&type=style&index=0&id=ecf99480&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf99480",
  null
  
)

export default component.exports